/**
 * enInventory — the Business Hub Inventory list; enOrders — its transactions
 * tab (Orders for a store, Subscriptions for SaaS, Bookings for a service…),
 * where `{transactions}` is the account's own plural noun from
 * `getClientPreset(...).nouns.transaction`.
 *
 * Split out of `en.ts`, which sits at the 500-line ceiling the `fileSize`
 * ratchet enforces.
 */
export const enInventory = {
  'inventory.pageTitle': 'Products',
  'inventory.pageSubtitle': 'Catalog, pricing, and inventory in one place.',

  'inventory.addProduct': 'Add Product',
  'inventory.emptyTitle': 'No products yet',
  // Primary next step is Add Product — "Connect your store" was a dead end
  // while Shopify connect is Coming soon (same decision as orders.emptyBodyStore).
  'inventory.emptyBody':
    'Track stock, pricing, and margins here. Add your first product to get started.',
  'inventory.emptyCta': 'Add your first product',

  // A product without a usable image: the thumbnail's accessible name.
  'inventory.noImage': 'No product image',
  // Shopify does not track this product's stock — 0 means "unknown", not "sold out".
  'inventory.stockNotTracked': 'Stock not tracked',
  'inventory.foreignPricedExcluded': 'Inventory value and average price leave out {count} item(s) priced in another currency.',
  // The product's purchase page on the storefront — the link a recommendation sends.
  'inventory.viewInStore': 'View in store',
} as const;

export const enOrders = {
  'orders.pageTitle': 'Orders',
  'orders.pageSubtitle': 'Track orders, costs, and profit per order.',

  'orders.tabAll': 'All {transactions}',
  'orders.searchPlaceholder': 'Search {transactions}...',
  'orders.lossCount': 'Loss {Transactions}',
  'orders.lossNeedsReview': 'Needs review',
  'orders.lossAllProfitable': 'All profitable',
  'orders.emptyTitle': 'No {transactions} yet',
  // A store. "Connect your store" removed: connecting Shopify is Coming soon
  // (owner, 2026-10-10), so it was a dead end for a new merchant.
  'orders.emptyBodyStore':
    'Orders will appear here once customers start making purchases.',
  // Every other kind: no "store" to connect, so name what to do instead.
  'orders.emptyBody':
    '{Transactions} will appear here once they start coming in. Connect the app that records them in Account → Integrations.',
  'orders.emptyCta': 'Open Integrations',
  'orders.fulfillEmptyTitle': 'No items to fulfill',
  'orders.fulfillEmptyBody':
    'When orders come in that need to be fulfilled, they will appear here in the fulfillment queue.',
  'orders.shipmentsEmptyTitle': 'No shipments yet',
  'orders.shipmentsEmptyBody':
    'Shipments will appear here once orders have been fulfilled and shipped to customers.',
  'orders.returnsEmptyTitle': 'No returns yet',
  'orders.returnsEmptyBody':
    'Return requests and RMAs will appear here when customers initiate returns.',
} as const;
